import { Reducer } from 'redux';
import { IFilter, ListarVeiculosState, ListarVeiculosTypes } from './types';

const INITIAL_STATE: ListarVeiculosState = {
  data: [],
  error: false,
  loading: false,
  filter: {} as IFilter,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<ListarVeiculosState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ListarVeiculosTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ListarVeiculosTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case ListarVeiculosTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case ListarVeiculosTypes.FILTER:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case ListarVeiculosTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
